import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
export function PricingSection() {
  const [guaranteeOpen, setGuaranteeOpen] = useState(false);
  return <section id="pricing" className="py-[48px] md:py-[80px] px-4 bg-[#0F2340] relative overflow-hidden" data-id="element-145">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-white rounded-xl p-6 md:p-[52px] text-center shadow-2xl relative" data-id="element-147">
          <div className="mb-6 md:mb-8" data-id="element-148">
            <div className="inline-block bg-[#FFFBEB] text-[#C9A84C] font-bold px-4 py-1.5 rounded-full text-xs md:text-sm mb-5 md:mb-6 tracking-wider uppercase" data-id="element-149">
              Oferta Especial
            </div>

            {/* Product Image */}
            <div className="flex justify-center mb-6 md:mb-8" data-id="element-150">
              <img src="https://cdn.magicpatterns.com/uploads/eJe52iqhuRsMuEBWjZSfx1/Mocap_Master_resina.png" alt="Mesas Epoxi Pro — La Guía Maestra" className="w-full max-w-[280px] md:max-w-sm rounded-lg shadow-lg" data-id="element-151" />
            </div>

            {/* Price Display — Horizontal Before/After */}
            <div className="flex items-center justify-center gap-5 md:gap-10" data-id="element-152">
              {/* Before */}
              <div className="flex flex-col items-center" data-id="element-153">
                <span className="text-[10px] md:text-sm font-semibold uppercase tracking-widest text-gray-400 mb-1" data-id="element-154">
                  Antes
                </span>
                <span className="text-xl md:text-4xl text-gray-400 line-through decoration-[#DC2626]/50 decoration-[2px] font-medium font-heading" data-id="element-155">
                  $1.490
                </span>
              </div>

              {/* Divider */}
              <div className="w-px h-12 md:h-20 bg-gray-200" data-id="element-156"></div>

              {/* After */}
              <div className="flex flex-col items-center" data-id="element-157">
                <span className="text-[10px] md:text-sm font-semibold uppercase tracking-widest text-[#15803D] mb-1" data-id="element-158">
                  Ahora
                </span>
                <span className="text-[36px] md:text-[72px] font-bold text-[#1A3A5C] font-heading tracking-tight leading-none" data-id="element-159">
                  $690
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 text-left max-w-sm mx-auto mb-8 md:mb-10" data-id="element-160">
            <span className="flex items-center gap-3 text-body-main text-gray-700" data-id="element-161">
              <CheckIcon className="w-4 h-4 text-[#22C55E] shrink-0" data-id="element-162" /> Guía
              completa Mesas Epoxi Pro
            </span>
            <span className="flex items-center gap-3 text-body-main text-gray-700" data-id="element-163">
              <CheckIcon className="w-4 h-4 text-[#22C55E] shrink-0" data-id="element-164" /> Los 4
              bonos exclusivos
            </span>
            <span className="flex items-center gap-3 text-body-main text-gray-700" data-id="element-165">
              <CheckIcon className="w-4 h-4 text-[#22C55E] shrink-0" data-id="element-166" /> Acceso
              de por vida
            </span>
          </div>

          <a href="https://resinartesanal.store//cart/51954451415353:1" className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 md:px-[56px] py-4 md:py-[20px] bg-gradient-to-r from-[#C9A84C] to-[#E5C877] text-[#0F2340] font-bold text-[15px] md:text-[17px] rounded-md transition-transform hover:-translate-y-[3px] shadow-lg hover:shadow-xl mb-6 md:mb-8" data-id="element-167">
            <span data-id="element-168">COMPRAR AHORA</span>
            <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-169" />
          </a>

          {/* Payment Trust Logos */}
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-gray-500 mb-6 md:mb-8" data-id="element-170">
            <span className="flex items-center gap-1.5" data-id="element-171">
              <LockIcon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-172" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-173">
              <CreditCardIcon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-174" /> Todas las
              tarjetas
            </span>
          </div>

          {/* Compact Guarantee Block */}
          <div className="bg-[#F0FDF4] border border-[#BBF7D0] rounded-lg max-w-md mx-auto overflow-hidden" data-id="element-175">
            <button onClick={() => setGuaranteeOpen(!guaranteeOpen)} className="w-full flex items-center justify-between px-4 py-3 md:px-5 md:py-3.5 hover:bg-[#DCFCE7]/30 transition-colors" data-id="element-176">
              <div className="flex items-center gap-2" data-id="element-177">
                <ShieldCheckIcon className="w-5 h-5 text-[#15803D]" data-id="element-178" />
                <span className="text-sm md:text-base font-bold text-[#15803D]" data-id="element-179">
                  Garantía de 7 días
                </span>
              </div>
              <ChevronDownIcon className={`w-4 h-4 text-[#15803D] transition-transform duration-300 ${guaranteeOpen ? 'rotate-180' : ''}`} data-id="element-180" />
            </button>
            <AnimatePresence initial={false} data-id="element-181">
              {guaranteeOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-182">
                  <div className="px-4 pb-4 pt-1 md:px-5 md:pb-5 md:pt-1 text-center" data-id="element-183">
                    <p className="text-sm md:text-body-main text-gray-600 leading-relaxed" data-id="element-184">
                      Si no cumplió lo que prometió, te devolvemos el{' '}
                      <strong className="text-[#16A34A]" data-id="element-185">
                        100% de tu dinero
                      </strong>
                      . Devolución total{' '}
                      <strong className="text-[#16A34A]" data-id="element-186">sin preguntas</strong>.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </section>;
}